// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Progress} from "reactstrap";
import React from "react";
import type {Caller} from "../QueryPage";

export type UnlockEBadgeModalStateProps = {
    open: boolean,
    registrationCode?: string,
    isLoading: boolean,
    error?: any,
    caller: Caller
}

export type UnlockEBadgeModalDispatchProps = {

    unlockEBadge: (registrationCode: string, caller: Caller) => any,
    closeModal: () => any
}

type UnlockEBadgeModalProps = UnlockEBadgeModalStateProps & UnlockEBadgeModalDispatchProps;

export default function UnlockEBadgeModal(props: UnlockEBadgeModalProps) {


    return (
        <Modal isOpen={props.open} toggle={() => {
            if (!props.isLoading) {

                props.closeModal();
            }
        }}>
            <ModalHeader toggle={() => {

                if (!props.isLoading) {
                    props.closeModal();
                }
            }}>Warning</ModalHeader>
            <ModalBody>
                {
                    !props.isLoading && !props.error &&
                    <span>Are you sure to unlink {props.registrationCode}? Any user using any phone entering this code can redeem the e-Badge once unlinked.</span>
                }
                {
                    !props.isLoading && props.error &&
                    <Alert color={"danger"}>Failed. Please try again!</Alert>
                }
                {
                    props.isLoading &&
                    <span>OK. We are unlinking {props.registrationCode}</span>
                }

                {
                    props.isLoading &&

                    (<Progress animated color="danger" value="100" />)
                }
            </ModalBody>
            <ModalFooter>
                {
                    !props.isLoading && !props.error &&

                    [<Button key={1} color="danger" onClick={() => {
                        if (typeof props.registrationCode !== 'undefined') {
                            props.unlockEBadge(props.registrationCode, props.caller);
                        }
                    }}>Unlink</Button>,
                        <Button key={2} color="secondary" onClick={() => {
                            props.closeModal();
                        }}>Cancel</Button>]
                }

            </ModalFooter>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/ebadge/UnlockEBadgeModal.js